export const BudgetStatusKeys = {
  WAITING: 'waiting',
  APPROVED: 'approved',
};

export const BudgetTaskStatusKeys = {
  APPROVED: 'approved',
  DECLINED: 'declined',
};



// WEBPACK FOOTER //
// ./src/domain/budget.js